const $ = jQuery.noConflict();

const forms = {
    wrapper: $('.gform_wrapper'),
    hbsptWrapper: $('.hbspt-form'),
    select() {
        // Apply select2 plugin to gform select fields
        this.renderFields( this.wrapper.find('select:not([class*=select2])') );
    },
    hubspot() {
        // Add listener for after hubspot renders.
        if ( this.hbsptWrapper.length ) {
            window.addEventListener('message', event => {
                if ( event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady' ) {
                    this.renderFields( this.hbsptWrapper.find('select') );
                }
            });
        }
    },
    renderFields( selectFields ) {
        selectFields.each((i, select) => {
            const selectSingle = $(select);
            const placeholder = selectSingle.children('.gf_placeholder');
            selectSingle.select2({
                minimumResultsForSearch: 999,
                placeholder: placeholder.length ? placeholder.text() : 'Select an option',
                width: '100%',
                escapeMarkup: function (m) { return m; }
            });

            selectSingle.on('select2:close', () => {
                $('.select2-selection--single').blur();
            });

            $(window).on('resize', () => {
                selectSingle.select2('close');
            });
        });
    }
};

export default forms;